import * as React from 'react'

import { useRecoilValue } from 'recoil'
import useSWR from 'swr'

import URI from '../../../misc/classes/URI'
import background from '../../../misc/images/backgrounds/background_12.jpg'
import { IPressResponse } from '../../../models/Press'
import routes from '../../../router/routes'
import { locale } from '../../../state/locale/atoms/locale'
import { translate } from '../../../state/locale/selectors/translate'
import { ImageSection } from '../../_layout/ImageSection'
import PageWrapper from '../../_layout/PageWrapper'
import { Breadcrumbs } from '../../reusable/Breadcrumbs'
import { Loading } from '../../reusable/Loading'
import { Press } from '../../templates/Press'

const PressPage = () => {
  const i18n = useRecoilValue(translate).press
  const breadcrumbs = [
    {
      link: routes.press,
      title: i18n.breadcrumb,
    },
  ]
  const lang = useRecoilValue(locale)
  const { data, isValidating } = useSWR<IPressResponse>(URI.getPressUri(lang))

  return (
    <>
      <ImageSection id={'press'} image={background} />
      <PageWrapper>
        <Breadcrumbs base={breadcrumbs} />
        {isValidating && <Loading />}
        {!!data?.data.length && <Press data={data.data} />}
      </PageWrapper>
    </>
  )
}

export default PressPage
